// src/config/firebase.config.js
import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

// Firebase configuration from environment variables
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Check if Firebase is configured
const isConfigured = Object.values(firebaseConfig).every(value => value !== undefined);

let app;
let storage;
let auth;

if (isConfigured) {
    try {
        // Initialize Firebase
        app = initializeApp(firebaseConfig);

        // Initialize Firebase Storage
        storage = getStorage(app);

        // Initialize Firebase Auth
        auth = getAuth(app);

        //console.log('✅ Firebase initialized successfully');
    } catch (error) {
        console.error('❌ Firebase initialization error:', error);
    }
} else {
    console.warn('⚠️ Firebase is not configured. Please set up environment variables.');
    console.warn('Required variables:');
    console.warn('  - REACT_APP_FIREBASE_API_KEY');
    console.warn('  - REACT_APP_FIREBASE_AUTH_DOMAIN');
    console.warn('  - REACT_APP_FIREBASE_PROJECT_ID');
    console.warn('  - REACT_APP_FIREBASE_STORAGE_BUCKET');
    console.warn('  - REACT_APP_FIREBASE_MESSAGING_SENDER_ID');
    console.warn('  - REACT_APP_FIREBASE_APP_ID');
}

export { app, storage, auth, isConfigured };
